export default "__VITE_ASSET__2216278c__"